import React from 'react'
import { makeStyles } from 'transfix-ui/core'
import { theme } from 'transfix-ui/theme'
import { brandColors } from 'transfix-ui/theme/colors'
import { IDownloadSftpFilesReport } from 'types/graphqlTypes'

interface IDownloadSftpFilesReportProps {
  report: IDownloadSftpFilesReport
}

const useDownloadSftpFilesReportStyles = makeStyles({
  root: {
    marginTop: theme.spacing(2),
  },
  warning: {
    color: brandColors.warning1,
  },
  error: {
    color: brandColors.error1,
  },
  success: {
    color: brandColors.green2,
  },
})

export const DownloadSftpFilesReport = ({ report }: IDownloadSftpFilesReportProps) => {
  const classes = useDownloadSftpFilesReportStyles()

  const { errorMessage, inboundRawEdiFileIds, success, warningMessage } = report || {}

  return (
    <div className={classes.root}>
      {!success ? (
        <span className={classes.error}>{errorMessage}</span>
      ) : (
        <div>
          <hr />
          {warningMessage ? (
            <span className={classes.warning}>{warningMessage}</span>
          ) : (
            <span className={classes.success}>Success!</span>
          )}
          <br />
          {inboundRawEdiFileIds?.map(fileId => (
            <span key={fileId}>
              Downloaded:
              <a
                href={`${__ROOT__}/edi-tools/mapper-files/inbound/${fileId}/details`}
                target='_blank'
                rel='noreferrer'>
                {fileId}
              </a>
              <br />
            </span>
          ))}
          <strong>
            Note: Please refresh the list again. Once the files are downloaded, they are deleted
            from the remote SFTP server so they don&apos;t get processed again.
          </strong>
        </div>
      )}
    </div>
  )
}
